import React from 'react';
import { WithSearch } from '@elastic/react-search-ui';
import CustomPagination from './CustomPagination';

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = React.useState<boolean>(() => (typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false));
  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    const mql = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [breakpoint]);
  return isMobile;
}
/**
 Integrates with react-search-ui and switches pagination layout for mobile/desktop.
 */
export default function CustomPaginationView({
  pagingContainer,
  resultsContainerRef,
}: {
  pagingContainer: string;
  resultsContainerRef?: React.RefObject<HTMLElement>;
}) {
  const isMobile = useIsMobile(768); // TODO: make breakpoint configurable and/or not a magic number
  return (
    <WithSearch
      mapContextToProps={({ current, totalPages, setCurrent }) => ({
        current: current || 1,
        totalPages: totalPages || 1,
        setCurrent,
      })}
    >
      {(props) => {
        const handlePageChange = (page: number) => {
          // Use the passed ref object directly
          if (resultsContainerRef && resultsContainerRef.current) {
            resultsContainerRef.current.scrollIntoView({ behavior: 'smooth' });
          } else {
            // Fallback to window scroll if no ref is provided or current is null
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }

          // Call the original function
          props.setCurrent(page);
        };

        return (
          <CustomPagination
            {...props}
            setCurrent={handlePageChange} // <-- Use our new handler
            pagingContainer={pagingContainer}
            isMobile={isMobile}
            visiblePages={4}
          />
        );
      }}
    </WithSearch>
  );
}
